export default "__VITE_ASSET__7e125b80__"